import React from "react";
import BreadcrumbTile from "../../components/UI/BreadcrumbTile";


function Breadcrumb() {

  return (
    <div className="container">
      <BreadcrumbTile />
    </div>
  )
}


export default Breadcrumb;